<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form class="fn-clear" :inline="true">
          <!-- <el-form-item label="" class="fn-left">
            <el-checkbox v-model="listQuery.tll_status" true-label="20062018214508001072" false-label="">只看已无效的例子</el-checkbox>
          </el-form-item> -->
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnInit()">初始化</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <wq-table ref="puchselisttable" :url-func="$http.shopPurchaseNoteSwitch">
        <el-table-column label="店铺" prop="name" align="center" />
        <el-table-column label="周采购" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.switch.switch1" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" @change="fnSwich(row.id,row.switch,'switch1')" />
          </template>
        </el-table-column>
        <el-table-column label="月采购" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.switch.switch2" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" @change="fnSwich(row.id,row.switch,'switch2')" />
          </template>
        </el-table-column>
        <el-table-column label="" align="center">
          <template slot="header">
            <span>
              紧急采购
              <el-tooltip
                class="item"
                effect="dark"
                content="额外增加200元成本（可选全部物品）"
                placement="top-start"
              >
                <i class="el-icon-question" style="color:white; margin:0px;margin-left:1px;height: 19px;" />
              </el-tooltip>
            </span>
          </template>
          <template slot-scope="{row}">
            <el-switch v-model="row.switch.switch3" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" @change="fnSwich(row.id,row.switch,'switch3')" />
          </template>
        </el-table-column>
        <el-table-column label="补货采购" align="center">
          <template slot="header">
            <span>
              补货采购
              <el-tooltip
                class="item"
                effect="dark"
                content="漏发补发申请，需要平掉校区库存（可选周采购物品）"
                placement="top-start"
              >
                <i class="el-icon-question" style="color:white; margin:0px;margin-left:1px;height: 19px;" />
              </el-tooltip>
            </span>
          </template>
          <template slot-scope="{row}">
            <el-switch v-model="row.switch.switch4" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" @change="fnSwich(row.id,row.switch,'switch4')" />
          </template>
        </el-table-column>
        <el-table-column label="一般采购" align="center">
          <template slot="header">
            <span>
              一般采购
              <el-tooltip
                class="item"
                effect="dark"
                content="可选全部物品并无额外费用"
                placement="top-start"
              >
                <i class="el-icon-question" style="color:white; margin:0px;margin-left:1px;height: 19px;" />
              </el-tooltip>
            </span>
          </template>
          <template slot-scope="{row}">
            <el-switch v-model="row.switch.switch5" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" @change="fnSwich(row.id,row.switch,'switch5')" />
          </template>
        </el-table-column>
      </wq-table>

    </div>

  </div>

</template>
<script>

import WqTable from '@/components/WqTable'

export default {
  name: 'TurnStudentList',
  components: {
    // Select
    WqTable
  },

  data() {
    return {
      lists: [],
      tableKey: 0
    }
  },
  created() {

  },
  methods: {
    fnInit() {
      this.$confirm('确定初始化吗？初始化后数据将会被还原，谨慎操作!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.shopPurchaseNoteSwitchInit().then((res) => {
          if (res.code == 200) {
            this.$message({ type: 'success', message: '操作成功!' })
          }
        })
      })
    },
    fnSwich(id, switchs, type) {
      this.$http.setShopPurchaseNoteSwitch({
        shop_id: id,
        value: switchs[type],
        key: type
      }).then((res) => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: '操作成功!' })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.el-image-viewer__wrapper .el-icon-circle-close {
  color:white
}
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
